// extracted by mini-css-extract-plugin
export default {"productGrid":"sZ-z","centerLink":"tZ-z","productSection":"uZ-z","item":"vZ-z","ctaButton":"wZ-z"};